<template>
<div ref="livePlayer" style="width:100%">
<div hidden class="seasoncast-card " style="margin-bottom: 5px"> {{ channel.name }} is live. <router-link v-bind:to="'/'+channel.id">[Switch to Live]</router-link></div>
<div class="videoDisplay" v-if="status == 'discovery'"><div class="p-2">Retriving channel status....</div></div>
<div class="videoDisplay" v-if="status == 'notLive'" ><div class="p-2"><b>{{ channel.name }} is not live</b><br />

<div v-if="future_event" style="color:#ededed">
  <br />
  Next Scheduled Event: {{ future_event.eventName }} <br />
   {{ new Date(future_event.timeStart * 1000).toLocaleDateString()}} | {{ new Date(future_event.timeStart * 1000).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}}<br />
<VueCountdown :time="future_event.timeStart*1000 - new Date().getTime()">
  <template slot-scope="props">Live in: {{ props.days > 0 ? props.days +" day"+ (props.days == 1 ? "" :"s")+", " : "" }}{{  zeroPad(props.hours,2) }}:{{ zeroPad(props.minutes,2) }}:{{ zeroPad(props.seconds,2) }}</template>
</VueCountdown>
</div>
</div></div>
<div class="videoDisplay" v-if="status == 'change'"><div class="p-2"><b>Waiting for video feed: {{ event ? event.eventName : channel.name }}</b><br /><small>broadcaster is live</small></div></div>
<div class="videoDisplay" v-if="status == 'ended'"><div class="p-2"><b>Thank you for watching {{ event ? event.eventName : channel.name }}</b></div></div>

<div class="videoDisplay" v-if="status == 'communityPassword'"><div class="p-2"> Channel {{channel.isVODLockOnly ? "VOD" : ""}} Locked: <input type="password" class="form-control" id="exampleInputPassword1" v-model="inputCP" placeholder="Enter Community Password"><button @click="testCP" style="margin-top:5px" class="btn btn-block btn-primary ">Submit</button></div></div>
<div class="videoDisplay" v-if="status == 'seasonPassOffer'"><div class="p-2"> You need to be a SeasonPass Holder to watch this channel. <router-link v-bind:to="'/viewer/lock/'+channel.id" style="margin-top:5px" class="btn btn-block btn-primary ">Become a SeasonPass Holder</router-link>

<div v-if="future_event" style="color:#ededed">
  <br />
  Next Scheduled Event: {{ future_event.eventName }} <br />
   {{ new Date(future_event.timeStart * 1000).toLocaleDateString()}} | {{ new Date(future_event.timeStart * 1000).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}}<br />
<VueCountdown :time="future_event.timeStart*1000 - new Date().getTime()">
  <template slot-scope="props">Live in: {{ props.days > 0 ? props.days +" day"+ (props.days == 1 ? "" :"s")+", " : "" }}{{  zeroPad(props.hours,2) }}:{{ zeroPad(props.minutes,2) }}:{{ zeroPad(props.seconds,2) }}</template>
</VueCountdown>
</div>
</div></div>
<div class="videoDisplay" v-if="status == 'viewerLogin'"><div class="p-2"> You need to be logged in to watch this channel. <router-link style="margin-top:5px" v-bind:to="'/viewer/login?return=/'+channel.id" class="btn btn-block btn-primary ">Login</router-link><router-link style="margin-top:5px" v-bind:to="'/viewer/create?return=/'+channel.id" class="btn btn-block btn-secondary ">Create Account</router-link></div></div>

<PlayerVue v-if="status == 'player'"  el="player" :source="source"   :options="options" @init="oninit" @error="onerror" @ended="onended" ></PlayerVue>

<br />
   <div class="row ">
         <div class="col-6">
             <div v-if="status == 'player'" >
         <h4>{{ event ?  event.eventName : recording ? recording.title :"" }}</h4>
        <p style="color:grey">   <i class="fa fa-user" aria-hidden="true"></i>
      {{ channel.name }}<br />
      <i class="fa fa-calendar" aria-hidden="true"></i> {{ event ? new Date(event.timeStart * 1000).toDateString() : (recording ? new Date(recording.onPub).toDateString() :"")}}
     
    
</p>
  </div>
         </div>
 <div class="col-6" style="text-align:right; width:100%">
       <h5><span  v-if=" recording_id && status == 'player'" style=" font-weight:normal" class="badge badge-info ">Past Broadcast</span> <span  v-if=" !recording_id && status == 'player'" style=" font-weight:normal" class="badge badge-danger ">Live</span> <span style=" font-weight:normal" v-if="event" class="badge badge-dark ">{{ event.global.sport}}</span></h5>    
             <small> <vue-goodshare-facebook v-bind:page_title="'Watch '+(recording_id ? recording.title : 'Live: '+channel.name)+' on SeasonCast'" has_icon button_design="outline" ></vue-goodshare-facebook><vue-goodshare-twitter has_icon button_design="outline" v-bind:page_title="'Watch '+(recording_id ? recording.title : 'Live: '+channel.name)+' on SeasonCast'"></vue-goodshare-twitter><VueGoodshareEmail  has_icon  title_social="Email" button_design="outline"></VueGoodshareEmail><router-link v-if="recording_id" v-bind:to="'/viewer/highlights/create/'+channel.id+'/'+recording_id" class="createHighlight">Create Highlight</router-link></small>
      </div>
      </div>
<hr v-if="event" />
<event v-if="event"  :event="event" :channel_id="channel.id"></event><br />
 <div v-if="event && event.events && event.events.length != 0" class="row ">
     <div class="col-12 col-md-6">
               <chart class="seasoncast-card" :eventData="event" v-if="event && event.events" :teams="event.teams" @watchTimeline="watchAtIndex"></chart>
<br />
       </div>
         <div class="col-12 col-md-6">
                            <tableGB class="seasoncast-card2" :eventData="event" v-if="event && event.events" :teams="event.teams"></tableGB><br />

  </div>


        </div>
</div>
</template>

<script>
import PlayerVue from './PlayerVue.vue'
import { Engine, initClapprPlayer } from "p2p-media-loader-hlsjs"
import VueGoodshareFacebook from "vue-goodshare/src/providers/Facebook.vue";
import VueGoodshareTwitter from "vue-goodshare/src/providers/Twitter.vue";
import VueGoodshareEmail from "vue-goodshare/src/providers/Email.vue";
import chart from "../gamebee/chart.vue"
import tableGB from "../gamebee/table.vue"
import event from "../Event.vue"
import axios from "axios"
  import cookie from "cookie.js"
  import Swal from "sweetalert2"
import ClapprMarkersPlugin  from "clappr-markers-plugin"
import VueCountdown from '@chenfengyuan/vue-countdown';

  var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

const noProgress = axios.create({
});
console.log(ClapprMarkersPlugin)
let API = "https://app.seasoncast.com/"
  export default {
  name: 'PlayerLive',
  components: {
    PlayerVue,
        VueGoodshareFacebook,
    VueGoodshareTwitter,
    VueGoodshareEmail,
    event,
    chart,
    tableGB,
    VueCountdown
   
  },
  props: { channel: {
        type: Object,
        required: true
    },
   recording_id: {
        type: String,
        required: false
    },
   
      event_id: {
        type: String,
        required: false
    },
    future_event: {
        type: Object,
        required: false
    },
    },
    
 data: () => ({
     status: "notLive",
     event: null,
     inputCP: null,
     recording: undefined,
      source:
        null,
      
      options: {
        width: "100%",
        height: "100%",
        poster: null,
        mute: false,
        autoplay: !iOS,
        loop: false,
        disable_keyboard_shortcuts: false,
        disable_context_menu: true,
        ga: {},
           controls: iOS,
    
   // chromeless: iOS,
        playback: {
    playInline: true,    
        },
        watermark: {},
        plugins: [ClapprMarkersPlugin],

         markersPlugin: {
    markers: [
    
    ],
    tooltipBottomMargin: 17 // optional
  }
        
      },
      localclappr: null,
    markers: [],
    engine: undefined
    }),
     watch:{
    recording_id: function(newVal, oldVal) { // watch it
          console.log('Prop changed: ', newVal, ' | was: ', oldVal)
      this.status = "discovery"
             if (this.recording_id) {
            this.getRecording()
            this.getRecordingEvent()
            return
        }
       this.isLive()
       
        }

    
  },
    mounted: async function(){
       // console.log(this.channel.community_password)
    
       this.options.markersPlugin.markers = this.markers
        // if (this.channel.community_password && !cookie.get(this.channel.id+"_cp")){
        //   if (this.recording_id)
        //     this.status = "communityPassword"
        //     return
        // }

               if (this.channel.isSeasonPass){
                   if (!cookie.get("viewer-token")){

 this.status = "viewerLogin"
 return
                   }else{
                     //test channel seasonpass
                     this.getViewerHasPass()
                   }
                   
        }
        if (this.recording_id) {
          document.title = this.channel.name + " | Watch on SeasonCast"

            this.getRecording()
            this.getRecordingEvent()
            return
        }
        
       this.isLive()
    },
    methods: {
      getViewerHasPass: async function () {
      
    let getEventResponse = await axios.post(API+ "v2/viewer/hasPass", {
    channel_id: this.channel.id,
    email: cookie.get("viewer-email"),
    token: cookie.get("viewer-token")
  }) 

  let responseData = getEventResponse.data
  console.log(responseData)

  if (responseData.success && !responseData.result.isExpired){
    console.log("vaild pass")
 
    //this.$router.push('/viewer/payment');
   
  }else{
    this.status = "seasonPassOffer"
  }
     },
      watchAtIndex: async function (index) {
if (this.recording_id) {
         var time = processTimeOnRecording( this.recording.timeStart, this.event.events[index].time, this.recording.duration)

    console.log(time)
if (time){
this.localclappr.core.mediaControl.container.seek(time)
}
}
        },
          getRecording: async function () {
      
    let getEventResponse = await axios.post(API+ "v2/channel/recording", {
    channel_id: this.channel.id,
     recording_id: this.recording_id,
 
  }) 

  let responseData = getEventResponse.data

  if (!responseData.success){
      await Swal.fire({
  icon: 'error',
  title: 'Server Error',
  text: 'server error: '+JSON.stringify(responseData.reason),
  footer: 'Try action later or refresh page'
})
this.$router.push('/');
return
  }

console.log(responseData)
  this.recording = responseData.recording
    

document.title = this.recording.title + " | Watch on SeasonCast"

if (this.recording.event){
this.getEvent(this.recording.event)
}
    },
        testCP: async function () {

            let getEventResponse = await axios.post(API+ "v2/viewer/testCP", {
    channel_id: this.channel.id,
    community_password: this.inputCP
  }) 

  let responseData = getEventResponse.data

  if (!responseData.success){
   await Swal.fire({
  icon: 'info',
  title: 'Incorrect community password',
  text: 'Please try again or ask broadcaster for password'
})
  return
  }
cookie.set(this.channel.id+"_cp",this.inputCP, { path: '/' })

              if (this.channel.isSeasonPass){
                   if (!cookie.get("viewer-token")){
 this.status = "viewerLogin"
 return
                   }
        }
if (this.recording_id){
  
              this.getRecording()
            this.getRecordingEvent()
  return
}
  this.status = "notLive"
  this.isLive()
        },
         getEvent: async function (event_id) {
      
    let getEventResponse = await axios.post(API+ "v2/channel/event", {
    channel_id: this.channel.id,
    event_id: event_id
  }) 

  let responseData = getEventResponse.data

  if (!responseData.success){
//        await Swal.fire({
//   icon: 'error',
//   title: 'Error',
//   text: 'message: '+JSON.stringify(responseData.reason),
//   footer: 'Try action later or refresh page'
// })

  }
console.log(responseData)
  this.event = responseData.eventData
  console.log(this.recording)
  if (this.recording_id){
   var markersPlugin = this.localclappr.getPlugin('markers-plugin')
  for (let index = 0; index < this.event.events.length; index++) {
   
    const element = this.event.events[index];
    var time = processTimeOnRecording( this.recording.timeStart, element.time, this.recording.duration)

    console.log(element)
if (time){

  var overallScore = ""

if (this.event.teams.length == 2){

  if (element.scores[0] == element.scores[1]){
    overallScore = " : Tied "+element.scores[0]+"-"+element.scores[1]
  }else if (element.scores[0] > element.scores[1]){
  overallScore = " : "+this.event.teams[0].name+" Leads "+element.scores[0]+"-"+element.scores[1]
  } else if (element.scores[0] < element.scores[1]){
 overallScore = " : "+this.event.teams[1].name+" Leads "+element.scores[1]+"-"+element.scores[0]
  }
}


  var output = "["+(this.event.teams[element.teamID] ? this.event.teams[element.teamID].name : "Global") + "] "+element.description + overallScore
  markersPlugin.addMarker(new ClapprMarkersPlugin.StandardMarker(time - 5, output))
}
     //  this.markers.push( new ClapprMarkersPlugin.StandardMarker(0, "yrds"))
  }
  }
         },
         zeroPad(num, places) {
  var zero = places - num.toString().length + 1;
  return Array(+(zero > 0 && zero)).join("0") + num;
},

        getLiveEvent: async function () {
         let getResponse = await axios.post(API+ "v2/viewer/watch/live", {
    channel_id: this.channel.id,
    viewer_token: cookie.get("viewer-token"),
    community_password: cookie.get(this.channel.id+"_cp")
  }) 

  let responseData = getResponse.data

  if (!responseData.success){
      //handle api failure

      switch (responseData.reason) {
          case "failure_auth_cp":
              console.log("need cp")
              this.status = "communityPassword"
              break;
          case "failure_auth_seasonpass":
              console.log("need auth")
              this.status = "seasonPassOffer"
              break;
          default:
              break;
      }
      return
  }
    if (this.channel.pageData){
  this.options.mediacontrol = { seekbar: "#"+this.channel.pageData.navcolor, buttons: "#"+this.channel.pageData.navcolor }
    }
     if ((!this.recording_id) && Engine.isSupported){
       const config = {
          segments:{
    // number of segments to pass for processing to P2P algorithm
    forwardSegmentCount:50, // usually should be equal or greater than p2pDownloadMaxPriority and httpDownloadMaxPriority
  },
  loader: {
       // how long to store the downloaded segments for P2P sharing
    cachedSegmentExpiration:86400000,
    // count of the downloaded segments to store for P2P sharing
    cachedSegmentsCount:100,

    // first 4 segments (priorities 0, 1, 2 and 3) are required buffer for stable playback
    requiredSegmentsPriority:3,

    // each 1 second each of 10 segments ahead of playhead position gets 6% probability for random HTTP download
    httpDownloadMaxPriority:9,
    httpDownloadProbability:0.06,
    httpDownloadProbabilityInterval: 1000,

    // disallow randomly download segments over HTTP if there are no connected peers
    httpDownloadProbabilitySkipIfNoPeers: false,

    // P2P will try to download only first 51 segment ahead of playhead position
    p2pDownloadMaxPriority: 50,

    // 1 second timeout before retrying HTTP download of a segment in case of an error
    httpFailedSegmentTimeout:500,

    // number of simultaneous downloads for P2P and HTTP methods
    simultaneousP2PDownloads:20,
    simultaneousHttpDownloads:3,


    // allow to continue aborted P2P downloads via HTTP
    httpUseRanges: true,

    trackerAnnounce: [
      "wss://tracker.openwebtorrent.com",
      "ws://tracker.viewer.seasoncast.com:8000"
    ],
    rtcConfig: {
      iceServers: [
        { urls: "stun:stun.l.google.com:19302" },
        { urls: "stun:global.stun.twilio.com:3478?transport=udp" }
      ]
    }
  }
       }

       this.engine = new Engine(config)
  this.options.playback = {hlsjsConfig: {
                   liveSyncDurationCount: 7,
                    loader:  (this.engine).createLoaderClass()
            }}

            // this.engine.on(Hyb, function (segment, peerId) {

            //   console.log( "["+peerId+"] "+segment)
            // })
              this.engine.on("segment_loaded", (segment, peerId) => console.log("segment_loaded from", peerId ? `peer ${peerId}` : "host", segment.url));
     }
  this.source = responseData.result.watch_url
  this.options.poster = "https://app.seasoncast.com/img/live_event.png"
  console.log(responseData.result)
  this.options.height = this.$refs.livePlayer.clientWidth / 16 * 9
    this.status = 'player'

this.getEvent(responseData.result.event_id)
 setTimeout(this.statReport, 20000)
        },
                getRecordingEvent: async function () {
                    console.log(this.recording_id)
         let getResponse = await axios.post(API+ "v2/viewer/watch/recording", {
    channel_id: this.channel.id,
    recording_id: this.recording_id,
    viewer_token: cookie.get("viewer-token"),
    community_password: cookie.get(this.channel.id+"_cp")
  }) 

  let responseData = getResponse.data

  if (!responseData.success){
      //handle api failure

      switch (responseData.reason) {
          case "failure_auth_cp":
              console.log("need cp")
              this.status = "communityPassword"
              break;
          case "failure_auth_seasonpass":
              console.log("need auth")
              this.status = "seasonPassOffer"
              break;
          default:
              break;
      }
      return
  }
 if (this.channel.pageData){
  this.options.mediacontrol = { seekbar: "#"+this.channel.pageData.navcolor, buttons: "#"+this.channel.pageData.navcolor }
 }
  this.options.poster = responseData.result.poster
  this.source = responseData.result.watch_url[0]

  //this.options.height = this.$refs.livePlayer.clientWidth / 16 * 9

    this.status = 'player'
    setTimeout(this.statReport, 20000)
 
        },
        statReport: async function(){
          var url = "https://"+this.channel.id+".mylivegame.com/stat/1/"+this.channel.id
          
          if (this.recording_id){
            url = "https://"+this.channel.id+".mylivegame.com/stat/0/"+this.recording_id
          }

          await noProgress.get(url)
        },
        isLive: async function () {
      
    let getResponse = await noProgress.post(API+ "v2/viewer/isLive", {
    channel_id: this.channel.id
  }) 

  let responseData = getResponse.data

  if (!responseData.success){
      //handle api failure
  }

  if (responseData.isChannelLive){
    if (!this.recording_id){
      this.getLiveEvent()
    }
  }else{
      setTimeout(this.isLive, 10000)
  }
            },

      oninit(clappr) {
        this.localclappr = clappr;
     //Engine.isSupported
        if (!this.recording_id && Engine.isSupported){
        initClapprPlayer(clappr)
        }
     // window.clappr = clappr
     if (!this.recording_id){
        window.$(".player-poster").append("<br /><p  style='width: 100%; position: absolute; padding:5px; bottom: 4%'><button style='width: 100%; margin-top:10px ' type='button' class='btn btn-danger'>Watch Live Event</button></p>")

     }else{
        window.$(".player-poster").append("<br /><p  style='width: 100%; position: absolute; padding:5px; bottom: 4%'><button style='width: 100%; margin-top:10px ' type='button' class='btn btn-info'>Watch Recording</button></p>")
     }
     },
      onready(event) {
        console.log('inside hook: onready', event);
      },
      onplay(event) {
        console.log('inside hook: onplay', event);
      },
      onpause(event) {
        console.log('inside hook: onpause', event);
      },
      onstop(event) {
        console.log('inside hook: onstop', event);
      },
      onended(event) {
       
        console.log('inside hook: onended', event);
         if (!this.recording_id){
         this.status = "ended"
         this.isLive()
         }
      },
      onfullscreen(isBool) {
        console.log('player fullscreen?', isBool);
      },
      onresize(resize) {
        console.log('Resized object', resize);
      },
      onseek(time) {
        console.log('on seek, time in seconds:', time);
      },
      ontimeupdate(progress) {
        console.log('Progress of played video:', progress);
      },
      onvolumeupdate(volume) {
        console.log('Volume updated, current volume:', volume);
      },
      onerror(e) {
         if (!this.recording_id){
        console.log('le error:', e);
        
      //  setTimeout(this.isLive(),4000)
        this.status = "change"
         setTimeout(this.isLive, 5000)
     
         }else{
          Swal.fire(
  'Recording Error',
  'Video playback issue. Video may still be processing up to 24 hours after broadcast. Issue report has been sent to SeasonCast. If issues continue, please contact SeasonCast support. ',
  'info'
)
console.log(this.localclappr)
 axios.post(API+ "v2/recording/reportIssue", {
    channel_id: this.channel.id,
    session: this.recording_id,
    //player_stats: this.localclappr._events 
  }) 

         }
      },
    },
  };


  function processTimeOnRecording( timestarts, eventTime, duration){
  

    for (let index = timestarts.length-1; index >= 0; index--) {
     const timeStamp = timestarts[index];
      var time = eventTime - timeStamp.ts
     if (time >= 0 && (timeStamp.time + time) <= duration) {
       return  (timeStamp.time + time)
     }
    }

     return  undefined

  }
</script>

<style scoped>
.videoDisplay{
    position:relative;width:100%;height:0;padding-bottom:56.25%;overflow:hidden;
    background-color: black;
    color: white;
    text-align: center;
}

.createHighlight{
    background-color: white;
    color: #363434;
    display: inline-flex;
    cursor: pointer;
    padding: 7px 10px;
   
    margin: 3px 1.5px;
    border-radius: 3px;
    -moz-border-radius: 3px;
    -webkit-border-radius: 3px;
    border: 1px solid  #363434;
}
.createHighlight:hover{
background-color: #e7e7e7;
}
.play-wrapper{
opacity: 0.97;
}

</style>